import React, { useEffect, useState } from "react";
import { BlueTickIcon, PlanFeaturesTickIcon, PlanFeatureTickIcon } from "../../icon";
import ButtonComponent from "../shared/button/button.component";
import { ChannelPlanModel, NewChannelPlanModel, ValidityType } from "../../models/users.model";
import { ChannelUserService } from "../../services/ChannelUserService";
import { useNavigate } from "react-router";
import { AppRoutes } from "../routes/route.path";

interface IProps {
    Plan: NewChannelPlanModel;
    HandlePlanSelect: (value: NewChannelPlanModel) => void;
    CurrentPlan?: ChannelPlanModel;
}


const PlanContainerComponent: React.FC<IProps> = (Props: IProps) => {

    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const handlePlansQuantity = (value) => {
        if (value !== 0 && (Props.CurrentPlan ? value >= Props.CurrentPlan.Quantity : true)) {
            Props.HandlePlanSelect({ ...Props.Plan, Quantity: value })
        }
    }

    const handlePayment = () => {
        setIsLoading(true)
        if (Props.CurrentPlan && (Props.Plan.Type !== ValidityType.ONETIME)) {
            ChannelUserService.ChangePlan({ quantity: Props.Plan.Quantity, price_id: Props.Plan.PriceId }).then((res) => {
                setIsLoading(false)
                window.location.href = res.data.url
            }).catch(() => {
                setIsLoading(false)
                navigate(`${AppRoutes.CHANNELS_PLANS}?canceled=true`)
            })
        }
        else {
            ChannelUserService.BuyPlan({ organization_id: ChannelUserService.getCurrentUserFromLocalStorage().OrganizationID, product_id: Props.Plan.ProductId, quantity: Props.Plan.Quantity, price_id: Props.Plan.PriceId, mode: Props.Plan.Type }).then(
                (res) => {
                    setIsLoading(false)
                    window.location.href = res.data.url
                }).catch(() => {
                    setIsLoading(false)
                    navigate(`${AppRoutes.SELECT_PLAN}?canceled=true`)
                })
        }
    }


    return (
        <div className={`w-40 m-2 p-relative ${Props.Plan.PriceId === Props.CurrentPlan?.PriceId && "disabled"}`} onClick={Props.Plan.Selected ? () => { } : () => { Props.HandlePlanSelect(Props.Plan) }}>
            {(Props.Plan.Type === ValidityType.ONETIME || Props.Plan.PriceId === Props.CurrentPlan?.PriceId) && <div className={`w-14 color-secondary ${Props.Plan.PriceId === Props.CurrentPlan?.PriceId ? "bg-color-disabled-btn" : "bg-color-primary-link"} h5-medium h-3 br-4 p-absolute t-n-1 r-13 mx-auto d-flex justify-center align-center`}>{Props.Plan.PriceId === Props.CurrentPlan?.PriceId ? "Current Plan" : "LIMITED TIME"}</div>}
            <div className={`px-3 pb-4 ${Props.Plan.Selected ? "onboarding-checkpoints-count-border-active" : "profile-border"} br-5 c-pointer`}>
                <div className="d-flex align-center h-1 justify-flex-end mt-2">
                    {Props.Plan.Selected && <PlanFeaturesTickIcon className="w-3 h-3 mt-2" />}
                </div>
                <div className="h2-semibold">
                    {Props.Plan.Name}
                </div>
                <div className="my-1 h5-medium color-plans-secondary-text-color">
                    {Props.Plan.Desc}
                </div>
                <div className="mb-1 mt-2 dashboard-sms-heading">
                    ${Props.Plan.Price}
                </div>
                <div className="mb-4 h5-medium color-plans-secondary-text-color">
                    {`per user/${Props.Plan.Type === ValidityType.MONTHLY ? "Month" : Props.Plan.Type === ValidityType.YEARLY ? "Year" : "One Time Payment"}`}
                </div>
                {Props.Plan.Features?.map(x => {
                    return <div className="d-flex h5-regular my-1">
                        <PlanFeatureTickIcon className="mr-1" /> {x}
                    </div>
                })}
                {
                    Props.Plan.Selected &&
                    <div className="w-p-100">
                        <div className="bb-display-background-4 mt-4"></div>
                        <div className="w-p-100 d-flex h-4 mt-4">
                            <div className="flex-1 ">
                                <div className="h4-semibold">
                                    Quantity
                                </div>
                                <div className="h6-regular color-plans-secondary-text-color">
                                    Add more later
                                </div>
                            </div>
                            <div className="w-4 h-4 d-flex justify-center align-center h3-medium b-around-text-field-border-4 br-1 c-pointer" onClick={() => { handlePlansQuantity(Props.Plan.Quantity - 1) }}>
                                −
                            </div>
                            <div className="w-4 h-4 mx-1 d-flex justify-center align-center h3-semibold">
                                {Props.Plan.Quantity}
                            </div>
                            <div className="w-4 h-4 d-flex justify-center align-center h3-medium b-around-text-field-border-4 br-1 c-pointer" onClick={() => { handlePlansQuantity(Props.Plan.Quantity + 1) }}>
                                ＋
                            </div>
                        </div>
                        <div className="p-1 bg-color-loader-backdrop br-3 my-2">
                            <div className="d-flex justify-between h4-medium py-1">
                                <div className="h6-regular color-plans-secondary-text-color">
                                    {`${Props.Plan.Quantity} ${Props.Plan.Quantity === 1 ? "plan" : "plans"}`}
                                </div>
                                <div className="h5-medium">
                                    {`$${Props.Plan.Price} × ${Props.Plan.Quantity}`}
                                </div>
                            </div>
                            <div className="bb-primary-background-pink-2"></div>
                            <div className="d-flex justify-between h4-medium py-1">
                                <div className="h4-medium">
                                    Total
                                </div>
                                <div className="h3-semibold color-primary-light">
                                    {`$${Props.Plan.Price * Props.Plan.Quantity}`}
                                    {<span className="footnote-medium color-primary-accent">{Props.Plan.Type === ValidityType.MONTHLY ? "/Mon" : Props.Plan.Type === ValidityType.YEARLY ? "/Year" : "/One Time Payment"}</span>}
                                </div>
                            </div>
                        </div>

                        {Props.Plan?.HasTrial && <div className="h-5 d-flex br-2 d-flex justify-center align-center plan-trail-box h5-medium">
                            <PlanFeatureTickIcon className="mr-1" /> {Props.Plan?.TrialDays}-day free trail included
                        </div>
                        }
                        {!!Props.CurrentPlan && <div className="h-5 d-flex br-2 d-flex justify-center align-center plan-trail-box h5-medium mt-1">
                            <PlanFeatureTickIcon className="mr-1" /> {Props.Plan.Price > (Props.CurrentPlan?.Price / 100) ? "Takes effect immediately" : "Takes effect at the end of billing cycle"}
                        </div>
                        }
                        {!!Props.CurrentPlan && Props.Plan.Price > (Props.CurrentPlan.Price / 100) &&
                            <>

                                <div className="bb-display-background-4 mt-4"></div>
                                <div className="d-flex justify-between h4-medium py-1">
                                    <div className="h6-regular color-plans-secondary-text-color">
                                        Today's charge (prorated)
                                    </div>
                                    <div className="h5-medium">
                                        {`$${(((Props.Plan.Price * Props.Plan.Quantity) - Props.CurrentPlan?.Unused_Amount) > 0 ? (Props.Plan.Price * Props.Plan.Quantity) - Props.CurrentPlan?.Unused_Amount : 0.00)?.toFixed(2)}`}
                                    </div>
                                </div>
                                <div className="d-flex justify-between h4-medium py-1">
                                    <div className="h6-regular color-plans-secondary-text-color">
                                        Next Full Billing Cycle
                                    </div>
                                    <div className="h5-medium">
                                        {Props.CurrentPlan?.End_Date}
                                    </div>
                                </div>
                            </>

                        }
                    </div>
                }
            </div>
            {
                Props.Plan.Selected &&
                <>
                    <ButtonComponent ButtonLabel="Complete Payment" ClassName="w-p-100 h-5 my-2 br-3 h4-regular" Variant="primary-btn" Loading={isLoading} OnClick={handlePayment} />
                    <div className="footnote-medium d-flex flex-direction align-center color-plans-secondary-text-color">
                        <div className="w-space"> By completing this purchase, you agree to our</div>
                        <div>
                            <span className="color-primary-light mr-1"><a target="_blank" href="https://falkonsystems.com/terms-of-service/">Terms</a></span>
                            and
                            <span className="color-primary-light ml-1 w-space"><a target="_blank" href="https://www.falkonchat.com/privacy-policy">Privacy Policy</a></span>
                        </div>
                    </div>
                </>
            }
        </div>
    )
}

export default PlanContainerComponent;